import { HttpErrorResponse, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { ToastMessageService } from '../services/toastMessage.service';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const _ToastMessageService = inject(ToastMessageService);
  const _AuthService = inject(AuthService);
  
  return next(req).pipe(map(
    (event: HttpEvent<any>) => {
      return event;
    }
   ),

    catchError(
      (error: HttpErrorResponse) => {
        switch (error.status) {
          case 401:
            // handle not Authenticated case here
            _AuthService.logout();
            _ToastMessageService.toastOnError('error', error.message);
            break;

          case 403:
            // handle not Authorized case here
              _AuthService.logout();
             _ToastMessageService.toastOnError('error', error.message);
            break;

          case 404:
            // handle not found case here
            _ToastMessageService.toastOnError('error', error.error.Error[0]);
            break;
          case 500:
            // handle server error case here
            _ToastMessageService.toastOnError('error', error.error.Error[0]);
            break;
          default:
            _ToastMessageService.toastOnError('error', error.error.Error[0]);
            break;
        }

        return throwError(() => error);
      })
  );
};
